import { BodyText, Headline, Icon, IconPropsStrict, Stack } from '@servicetitan/design-system';
import { FC } from 'react';

export const EmptyResults: FC<{
    className?: string;
    title: string;
    description: string;
    image?: string;
    iconName?: IconPropsStrict['name'];
}> = ({ className, description, iconName, image, title }) => (
    <Stack direction="column" justifyContent="center" alignItems="center" className={className}>
        {image ? (
            <img src={image} alt="" />
        ) : (
            <Icon name={iconName ?? 'not_interested'} className="c-red-500" size={40} />
        )}
        <Headline className="m-t-2" size="medium">
            {title}
        </Headline>

        <BodyText className="ta-center" size="xsmall" subdued>
            {description}
        </BodyText>
    </Stack>
);
